module.exports = __webpack_public_path__ + "3a8cd53c5c692039c587f931de5d9349.png";